import { DataType, TableColumn } from '~/common/generated/apollo-operations'
import { LookupCell } from '~/components/records/lookup/LookupCell'
import {
  AddRecordFormCell,
  RecordDetailTableCell,
  RecordDetailTableRow,
} from '~/components/records/types'

interface LookupArrayCellDetailsProps {
  cell: RecordDetailTableCell | AddRecordFormCell
  showDirtyIndicator: boolean
  onCancel?: () => void
  columnWidth?: number
  parentRow?: Omit<RecordDetailTableRow, 'table' | 'rootWorkspace'>
  columns: Pick<TableColumn, 'id' | 'type' | 'innerType' | 'indexType'>[]
  selectedLookupRowIds: string[]
  row?: Pick<RecordDetailTableRow, 'cells'>
}

/**
 * Renders record cell details for a column of type ARRAY with inner type Lookup
 */
export function LookupArrayCellDetails({
  cell,
  showDirtyIndicator,
  onCancel,
  columnWidth,
  parentRow,
  columns,
  selectedLookupRowIds,
  row,
}: LookupArrayCellDetailsProps) {
  if (cell.column.innerType !== DataType.LOOKUP) {
    return null
  }

  return (
    <LookupCell
      cell={cell}
      columnWidth={columnWidth}
      columns={columns}
      lookupGroupId={cell.column.lookupColumnGroup?.id}
      onCancel={onCancel}
      parentRow={parentRow}
      row={row}
      selectedLookupRowIds={selectedLookupRowIds}
      showDirtyIndicator={showDirtyIndicator}
    />
  )
}
